/**
 * Authenticated fetch wrapper.
 * Reads JWT from localStorage (set by LoginPage) and attaches Bearer header.
 */

const API = process.env.REACT_APP_ACQUISITION_API || 'http://localhost:5500';

function getAuthHeaders(): Record<string, string> {
    const headers: Record<string, string> = { 'Content-Type': 'application/json' };
    try {
        const saved = localStorage.getItem('acq_auth');
        if (saved) {
            const auth = JSON.parse(saved);
            if (auth.token) headers['Authorization'] = `Bearer ${auth.token}`;
        }
    } catch { /* ignore */ }
    return headers;
}

export async function authFetch(path: string, options: RequestInit = {}): Promise<Response> {
    const authHeaders = getAuthHeaders();
    return fetch(`${API}${path}`, {
        ...options,
        headers: {
            ...authHeaders,
            ...(options.headers || {}),
        },
    });
}

export { API };
